const appConfig = window.appConfig

export default appConfig


// WEBPACK FOOTER //
// ./src/config/applicationConfig.js